module.exports = __webpack_public_path__ + "img/managers.efe25c0d.svg";